// External dependencies
import React from 'react';
import styled from 'styled-components';

// Zocdoc dependencies
import { FacebookInverted as FacebookIcon } from '@zocdoc-frontend-common/assets-icons';

import BaseSocialLoginButtonTransparent from './BaseSocialLoginButtonTransparent';

export default function FacebookLoginButtonTransparent({
    message = 'Continue with Facebook',
    ...props
}) {
    return (
        <StyledLoginButton
            icon={StyledFacebookIcon}
            message={message}
            {...props}
        />
    );
}

const StyledFacebookIcon = styled(FacebookIcon)`
    color: #4267b2;
    font-size: 22px;
`;

const StyledLoginButton = styled(BaseSocialLoginButtonTransparent)`
    &:hover,
    &:active {
        ${StyledFacebookIcon} {
            color: white;
        }
    }
`;
